import React from 'react'
import { Link } from 'react-router-dom'
import cx from 'classnames'
import _ from 'lodash'
import { Record } from './gql-types/Record'
import { useGlobalContext } from 'components/context'
import { formUrl } from 'utils/url';

type Props = {
	// dont need this double NonNullable after big migration
    dashboard: NonNullable<NonNullable<Record["record"]["template"]>["formSet"]["dashboard"]>
    record: Record["record"]
}

type Field = Props["dashboard"]["dashboardFields"][0]
type Section = Props["dashboard"]["sections"][0]
type FieldItem = {
    type: 'field'
} & Field
type SectionItem = {
    type: 'section'
} & Section

export default (props: Props) => { 
	let fields: {[k: string]: Field} = {}
	let sections: {[k: string]: Section} = {}
	props.dashboard.dashboardFields.forEach(f => fields[f.rank] = f) // this will clobber fields with same rank
	props.dashboard.sections.forEach(s => sections[s.rank] = s)
	const context = useGlobalContext()
	let ranks = [...Object.keys(fields), ...Object.keys(sections)].map(i => parseInt(i))
	ranks = _.sortBy(_.uniq(ranks))



	let allList: (FieldItem | SectionItem)[] = []
	ranks.map(r => {
		if(sections[r]) {
			allList.push({...sections[r], type: 'section'})
		}
		if(fields[r]) {
			allList.push({...fields[r], type: 'field'})
		}
	})

	let hideFieldsList: typeof allList = []

	allList.map((item, i) => {
		if(item.type == 'section') {
			hideFieldsList.push(item)
		}
		else {
			if(item.hideIfBlank && item.answers.length == 0) {
			}
			else {
				hideFieldsList.push(item)
			}
		}
	})

	//hide sections with no fields (due to team visiblility)
	let hideSectionsList: typeof allList = []
	hideFieldsList.map((item, i) => {
		if(item.type == 'section') {
			if(i == hideFieldsList.length - 1) {
			}
			else if(hideFieldsList[i+1].type == 'section') {
			}
			else {
				hideSectionsList.push(item)
			}
		}
		else {
			hideSectionsList.push(item)
		}
	})

	return (
		<div className="form-set-dashboard">
			{hideSectionsList.map((item, i) => 
				<div key={item.id + item.type}>
					{item.type == 'section' &&
						<h5 className="section">{item.name}</h5>
					}
					{item.type == 'field' &&
						<Link
							key={item.field.id}
							to={formUrl({recordId: props.record.id, formId: item.form, ...context})}
							className="field"
						>
							<span className="title">{item.field.title}:</span>

							{(item.answers.length == 0) ? 
								<span className="muted inline-content"> No content </span> 
							:
								item.answers.map((a, i) => 
									<span
										key={i}
										className={cx({
											"inline-content": item.answers.length == 1,
											"block-content": item.answers.length > 1
										})}
									>
										<span >
											{a}
										</span>
									</span>
								)
							}
						</Link>
					}
				</div>
			)}
		</div>
	)
}